module.exports = __webpack_public_path__ + "img/pin-icon-01.6adf3cbd.gif";